import React from 'react';
import { Rating } from '@material-ui/lab';
import { IRatingRow } from './types';

export const RatingRow = ({ row, ...props }: IRatingRow) => {
    return (
        <Rating
            value={row?.rating || 0}
            size="small"
            readOnly
            precision={0.5}
            {...props}
        />
    );
};
